import EntityTypeEnum from 'common/enums/entityTypeEnum'
import ChildrenEntities from 'publisher/components/ChildrenEntities'
import { usePage, useWebsiteSettings } from 'publisher/store'
import { getFirstEntityByType } from 'publisher/store/page/pageSelectors'
import React from 'react'
import {
  getWebsiteStylesLayout,
  getWebsiteThemeBackground,
} from 'src/publisher/store/website-settings/website-settings-selector'
import { CommonWebsitePageBody } from 'src/shared/entities/website-page-body'
import { CommonWebsitePageBodyNew } from 'src/shared/entities/website-page-body-new'
import { WebsitePageInterface } from 'src/shared/types/website-entities'

export interface WebsitePageBodyProps {
  entity: WebsitePageInterface
}

export const WebsitePageBody = ({ entity }: WebsitePageBodyProps) => {
  const layout = useWebsiteSettings(getWebsiteStylesLayout)
  const background = useWebsiteSettings(getWebsiteThemeBackground)
  const hasSection = !!usePage(page =>
    getFirstEntityByType(page, EntityTypeEnum.Section),
  )

  // NOTE: remove after migration is completed
  return hasSection ? (
    <CommonWebsitePageBodyNew htmlAttrId={entity.htmlAttrId}>
      <ChildrenEntities childIds={entity.childIds} />
    </CommonWebsitePageBodyNew>
  ) : (
    <CommonWebsitePageBody
      htmlAttrId={entity.htmlAttrId}
      contentWidth={layout?.contentWidth}
      background={
        background?.containerBackgroundColor ||
        background?.contentBackgroundColor
      }
    >
      <ChildrenEntities childIds={entity.childIds} />
    </CommonWebsitePageBody>
  )
}
